import DeleteRole from "./DeleteRole";
export default DeleteRole;
